import { type FC, type ReactNode } from "react";
import { PackageRestrictionContext } from "~/features/PackageRestriction/PackageRestrictionContext";
import { useCalculateRestrictedCode } from "~/features/PackageRestriction/hooks/useCalculateRestrictedCode";

interface Props {
  productCode: string;
  children?: ReactNode;
}
export const AutosuggestPackageRestrictionContext: FC<Props & { query: string }> = ({
  productCode,
  query,
  children,
}) => {
  const restrictedCode = query.length === 2 ? query : useCalculateRestrictedCode(query, productCode);

  return <PackageRestrictionContext value={restrictedCode}>{children}</PackageRestrictionContext>;
};
